/* eslint-disable */
import uiConfig from '@onereach/ui-config';
import config from '../env.json';
// @ts-ignore
import runningProjects from 'runningProjects';
// @ts-ignore
import localOverrides from 'localOverrides';
export default uiConfig(config, localOverrides, runningProjects);
